module.exports = function() {
  return new Worker(__webpack_public_path__ + "2e5599d94613e44c8a38.worker.js");
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/worker-loader/dist/cjs.js!./node_modules/pdfjs-dist/build/pdf.worker.js
// module id = 896
// module chunks = 170